@if (event) {
  <div class="flex justify-between gap-2">
    <div>
      @if (event && event?.type && colorsHistory[event.type]) {

        <div class="flex h-12 w-12 items-center justify-center rounded-xl {{colorsHistory[event.type]?.bgClass}} dark:bg-gray-800">
          <i class="fa fa-light text-2xl {{colorsHistory[event.type]?.icon}} {{colorsHistory[event.type]?.textClass}}"></i>
        </div>
      }
      @if (event.type && colorsHistory[event.type]) {
        <h6 class="media-heading text-center text-xs" [ngStyle]="{color: colorsHistory[event.type].primary}">
          {{event.type|titlecase}}
          @if (showPeopleTitle === true) {
            <people [break]="false" [people]="event?.createur" [showMediaPhoto]="true" [small]="true"></people>
          }
        </h6>
      }
    </div>



    @if (!event?.type || !colorsHistory[event.type]) {
      <h6 class="media-heading darken-1"
      >
        {{event.type|titlecase}}
        @if (showPeopleTitle === true) {
          <people [break]="false" [people]="event?.createur" [showMediaPhoto]="true" [small]="true"></people>
        }
      </h6>
    }
    <p class="notification-text text-sm text-right text-muted">{{event?.explain}}</p>

  </div>

}
